import React, {
    memo, useCallback, useEffect
} from 'react';
import PropTypes from 'prop-types';
import {CARD_LOGOS, ZEPZ_PAYMENT_FORM} from '../../../consts';
import {Ref} from '../../../utils/proptypes';
import {pushAnalyticsEvent} from '../../organisms/Analytics';
import {TokenExIframe} from '../../organisms/ZepzForm/zepz-form.services';


const ZepzCardNumberField = ({
    iframe, id, forwardRef, name, cardType
}) => {
    const onBlur = useCallback(() => {
        pushAnalyticsEvent({
            interactionName: 'form tracking',
            formName: ZEPZ_PAYMENT_FORM,
            formField: name
        });
    }, []);


    useEffect(() => {
        iframe?.onBlur(onBlur);
    }, [iframe, onBlur]);


    return (
        <div className="card-number-wrapper">
            <div id={id} ref={forwardRef} className="form-field-container zepz-card-number" />
            <img
                className="card-number-icon"
                src={CARD_LOGOS[cardType?.toLowerCase()] || CARD_LOGOS.cybersourceOther}
                alt="card number input"
            />
        </div>
    );
};


ZepzCardNumberField.propTypes = {
    iframe: PropTypes.instanceOf(TokenExIframe),
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    forwardRef: Ref.isRequired,
    cardType: PropTypes.string.isRequired
};

ZepzCardNumberField.defaultProps = {
    iframe: null
};


export default memo(ZepzCardNumberField);
